import { useState } from 'react'
import { logger } from '../utils'

// Hook
const useLocalStorage = (key: string, initialValue?: any) => {
  const Storage = window.localStorage
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from Storage by key
      const item = Storage.getItem(key)
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      // If error also return initialValue
      logger(error)
      return initialValue
    }
  })

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to Storage.
  const setValue = (value: any) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value
      // Save state
      setStoredValue(valueToStore)
      // Save to Storage
      Storage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      // A more advanced implementation would handle the error case
      logger(error)
    }
  }

  const clearValue = () => {
    try {
      // Clear Storage
      Storage.removeItem(key)
    } catch (error) {
      // A more advanced implementation would handle the error case
      logger(error)
    }
  }

  return [storedValue, setValue, clearValue]
}

export default useLocalStorage
